import styled from "styled-components";
import HeaderWithoutLogin from "../../components/HeaderWithoutLogin";
import AdvisorSideBar from "../../components/AdvisorSideBar/AdvisorSideBar";
import DashboardNavigationTool from "../../components/MarketPlaceComponents/DashboardNavigationTool/DashboardNavigationTool";
import MarketPlaceGalleryView from "../../components/MarketPlaceComponents/MarketPlaceGalleryView/MarketPlaceGalleryView";
import FIlterGroupSortContainer from "../../components/MarketPlaceComponents/FIlterGroupSortContainer/FIlterGroupSortContainer";

const BodyWrapper = styled.div`
  background-color: white;

  .sectionHeader {
    font-weight: 700;
    font-size: 20px;
    color: #004576;
    padding: 0px 20px;
  }

  .body-content {
    display: flex;
    gap: 15px;

    .body-section {
    }
  }
`;

const AdvisorMarketplace = () => {
  return (
    <BodyWrapper>
      <AdvisorSideBar activeSection={4} />

      <div style={{ marginLeft: "80px" }}>
        <HeaderWithoutLogin
          isLogoClickFromAdvisorPortal={true}
          isHelpButtonVisible={false}
        />
        <DashboardNavigationTool />
        <div className="body-content">
          <div className="body-section" style={{ minWidth: "260px" }}>
            <div className="sectionHeader">Curate Your Marketplace</div>
            <div style={{ paddingLeft: "20px", paddingTop: "20px" }}>
              <FIlterGroupSortContainer />
            </div>
          </div>
          <div style={{ width: "85%" }} className="body-section">
            <div className="sectionHeader">Marketplace</div>
            <MarketPlaceGalleryView />
          </div>
        </div>
      </div>
    </BodyWrapper>
  );
};

export default AdvisorMarketplace;
